import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiElementsModule } from 'src/app/components/elements/ui-elements.module';
import { ChatConnectorsModalComponent } from './chat-connectors-modal.component';

@NgModule({
  declarations: [ChatConnectorsModalComponent],
  imports: [CommonModule, FormsModule, UiElementsModule],
  exports: [ChatConnectorsModalComponent]
})
export class ChatConnectorsModalModule {}